import React, { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import { endpoint } from "../../api/endpoint";
import { apiHandler } from "../../api";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Loader as LoaderIcon } from "react-feather";
import styles from "./ProductReview.module.css";
import { FaInfoCircle } from "react-icons/fa";
import { CiSaveDown2 } from "react-icons/ci";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

const ProductReview = () => {
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  const { addToast } = useToasts();
  const [statuses, setStatuses] = useState([
    { iProductGalleryId: "", iStatusId: "" },
  ]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipData, setTooltipData] = useState(null);
  const [remarks, setRemarks] = useState({});
  const [products, setProducts] = useState([]);
  const [models, setModels] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const navigate = useNavigate();
  const [productSaveLoader, setProductSaveLoader] = useState(false);
  const dispatch = useDispatch();
  const [imgwidth, setImgWidth] = useState("");

  const handleStatusChange = (index, value, id) => {
    const updatedStatuses = [...statuses];
    updatedStatuses[index] = { iProductGalleryId: id, iStatusId: value };
    setStatuses(updatedStatuses);

    if (value !== "1") {
      setRemarks((prev) => ({ ...prev, [id]: "" }));
    } else {
      setRemarks((prev) => {
        const { [id]: _, ...rest } = prev;
        return rest;
      });
    }
  };

  const handleRemarkChange = (id, value) => {
    setRemarks((prev) => ({ ...prev, [id]: value }));
  };

  const allStatusesSet =
    statuses.length > 0 && statuses.every((status) => status.iStatusId !== "");
  const allRemarksSet = Object.keys(remarks).every(
    (id) => remarks[id].trim() !== ""
  );

  const handleSaveResult = () => {
    if (!allStatusesSet) {
      addToast("Please select a status for all products!", {
        appearance: "error",
      });
      return;
    } else if (!allRemarksSet) {
      addToast(
        "Please enter remarks for statuses that do not meet VTO specs!",
        {
          appearance: "error",
        }
      );
      return;
    } else saveProducts();
  };

  const fetchProducts = async () => {
    try {
      const result = await apiHandler({
        url: `${endpoint.PREVIEW_IMAGE}`,
        method: "GET",
        authToken: authData,
        storeId,
        dispatch,
      });
      if (result?.data?.status === "success") {
        const fetchedImages = result?.data?.data?.previewImages;
        setProducts(fetchedImages);
        setModels(result?.data?.data?.modelImage);
        setDropdownOptions(result?.data?.data?.dropdownData?.statusDropdown);
      }
    } catch (error) {
      console.log("Error fetching images", error);
    }
  };

  const saveProducts = async () => {
    try {
      setProductSaveLoader(true);
      const data = statuses.map((status) => {
        const remark = remarks[status.iProductGalleryId];
        return remark ? { ...status, sRemark: remark } : { ...status };
      });

      const result = await apiHandler({
        url: `${endpoint.PATCH_PREVIEW_IMAGE}`,
        method: "PATCH",
        authToken: authData,
        data: { aImagesJson: data },
        storeId,
        dispatch,
      });

      if (result?.data?.status === "success") {
        navigate("/productsandbox");
      }
    } catch (error) {
      console.log("Error saving image results", error);
    } finally {
      setProductSaveLoader(false);
    }
  };

  const handleMouseEnter = (product) => {
    setTooltipData(product);
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const calculatePosition = (
    coOrdinates,
    product,
    newwidth,
    newheight,
    prodHeight,
    prodWidth
  ) => {
    if (product.iBodyTypeId === 3) {
      const positions = [];
      const fingerNames = Object.keys(coOrdinates.coordinates).filter(
        (key) => key !== "hand" && key !== "sUUID" && key != "sImageURL"
      );
      console.log(coOrdinates, "coOrdinates");

      fingerNames.forEach((finger) => {
        const fingerData = coOrdinates.coordinates[finger][0];

        if (fingerData) {
          let [leftX, leftY] = fingerData.left;

          leftX = leftX * newwidth;
          leftY = leftY * newheight;

          let [rightX, rightY] = fingerData.right;
          rightX = rightX * newwidth;
          rightY = rightY * newheight;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          const length = Math.sqrt(
            Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
          );
          const aspectRatio = prodHeight / prodWidth;
          const angle =
            (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI;

          positions.push({
            left: centerX,
            top: centerY,
            rotationAngle: angle,
            height: length * aspectRatio,
            width: length + length * 0.1,
            leftX,
            leftY,
            rightX,
            rightY,
            centerX,
            centerY,
          });
        }
      });

      return positions;
    } else if (product.iBodyTypeId === 1) {
      if (coOrdinates) {
        let coOrdinates1 = coOrdinates.wrist
          ? coOrdinates.wrist.coordinates[0]
          : coOrdinates;
        let hand = coOrdinates.wrist
          ? coOrdinates.wrist.hand
          : coOrdinates.hand;
        const handCooridntaes = coOrdinates.hand;
        let [leftX, leftY] = coOrdinates1.left;
        leftX = leftX * newwidth;
        leftY = leftY * newheight;

        let [rightX, rightY] = coOrdinates1.right;
        rightX = rightX * newwidth;
        rightY = rightY * newheight;

        let centerX = (leftX + rightX) / 2;
        let centerY = (leftY + rightY) / 2;

        const length = Math.sqrt(
          Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
        );
        const aspectRatio = prodHeight / prodWidth;
        const angle =
          hand === "right"
            ? Math.abs(
                (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI
              )
            : Math.abs(
                (Math.atan2(leftY - rightY, leftX - rightX) * 180) / Math.PI
              );

        return {
          left: centerX,
          top: centerY,
          rotationAngle: angle,
          height: length * aspectRatio,
          width: length + length * 0.1,
        };
      }
    } else if (product.iBodyTypeId === 4) {
      let neckCoordinates = coOrdinates?.neck_coordinates?.neck_wide
        ? coOrdinates?.neck_coordinates?.neck_wide
        : coOrdinates?.neck_mask_wide;
      let [leftX, leftY] = neckCoordinates.left_point;
      leftX = leftX * newwidth;
      leftY = leftY * newheight;

      let [rightX, rightY] = neckCoordinates.right_point;
      rightX = rightX * newwidth;
      rightY = rightY * newheight;

      let centerX = (leftX + rightX) / 2;
      let centerY = (leftY + rightY) / 2;

      const length = Math.sqrt(
        Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
      );

      let angle = (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI;

      if (Math.abs(angle) < 5) {
        angle = 0;
      }

      return {
        left: centerX - length / 2 - length * 0.1,
        top: centerY - length / 2 - length * 0.1,
        rotationAngle: angle,
        height: length + length * 0.2,
        width: length + length * 0.2,
      };
    } else if (product.iBodyTypeId === 2) {
      let earCoordinates = coOrdinates?.ear_coordinates;
      let positions = [];
      let zoomfactor = coOrdinates?.zoom_factor;

      earCoordinates.forEach((earCoord) => {
        if (earCoord) {
          const [earX, earY] = earCoord;
          const x = earX * newwidth;
          const y = earY * newheight;

          const aspectRatio = product?.dProductHeight / product?.dProductWidth;
          const productImageHeight = 500 * product?.dProductHeight * zoomfactor;
          const productImageWidth =
            (500 * product?.dProductHeight * zoomfactor) / aspectRatio;
          positions.push({
            left: x,
            top: y,
            height:
              aspectRatio && product?.dProductHeight && zoomfactor
                ? productImageHeight
                : 60,
            width:
              aspectRatio && product?.dProductHeight && zoomfactor
                ? productImageWidth
                : 60,
          });
        }
      });

      return positions;
    } else {
      console.error("Finger data not found for the current finger.");
    }
  };

  useEffect(() => {
    if (products.length && models.length) {
      const processProductsWithModels = async () => {
        const updatedProducts = await Promise.all(
          products.map(async (product) => {
            const productImageDimensions = await new Promise((resolve) => {
              const img = new Image();
              img.src = product.sURL;

              img.onload = () => {
                const width = img.naturalWidth;
                const height = img.naturalHeight;

                resolve({ width, height });
              };

              img.onerror = () => {
                // Fallback in case image fails to load
                resolve({ width: 0, height: 0, newWidth: 500 });
              };
            });

            const filteredModels = models.filter(
              (model) => model.iBodyTypeId === product.iBodyTypeId
            );

            const loadImages = await Promise.all(
              filteredModels.map((model) => {
                return new Promise((resolve) => {
                  const coordinates = JSON.parse(model.sCoordinate);

                  const img = new Image();
                  img.src = model.sURL;

                  img.onload = () => {
                    const height = img.height;
                    const width = img.width;
                    const newWidth = (500 * width) / height;

                    setImgWidth(newWidth);

                    if (coordinates) {
                      const position = calculatePosition(
                        coordinates,
                        product,
                        newWidth,
                        500,
                        productImageDimensions.height,
                        productImageDimensions.width
                      );

                      resolve({ ...model, position }); // Return model with position
                    } else {
                      resolve(model); // Return original model if no coordinates
                    }
                  };

                  img.onerror = () => resolve(model); // In case of image load error
                });
              })
            );

            return { ...product, models: loadImages };
          })
        );
        setProducts(updatedProducts);
        // Now you can use updatedProducts with resolved model data
      };

      processProductsWithModels();
    }
  }, [models]);

  useEffect(() => {
    if (products.length > statuses.length) {
      setStatuses((prevStatuses) => [
        ...prevStatuses,
        ...Array(products.length - prevStatuses.length).fill({
          iProductGalleryId: "",
          iStatusId: "",
        }),
      ]);
    } else if (products.length < statuses.length) {
      setStatuses((prevStatuses) => prevStatuses.slice(0, products.length));
    }
  }, [products]);

  useEffect(() => {
    fetchProducts();
  }, []);
  console.log(models);

  return (
    <div className="min-h-screen">
      <div className={styles.topheader}>
        <div className="d-lg-flex d-sm-flex items-center justify-between">
          <div className="p-1 text-xl font-bold">Product Image Evaluation</div>
          {productSaveLoader ? (
            <button
              className={`screenFormSubmitLoaderBtn consistentBtn ${styles.modalbtn}`}
              style={{ width: "100px" }}
              disabled={productSaveLoader}
            >
              <LoaderIcon size={20} className="indicator" />
            </button>
          ) : (
            <button
              type="submit"
              className={`p-2 px-3 ${styles.modalbtn}`}
              onClick={handleSaveResult}
            >
              <CiSaveDown2 /> &nbsp; Save Result
            </button>
          )}
        </div>
      </div>

      <div className={` ${styles.middle_main_container}`}>
        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-8">
          {products.map((product, index) => (
            <div key={index} className="flex space-x-6">
              <div className="w-50">
                <div
                  className=" relative bg-gray-300 w-full"
                  style={{ height: "300px" }}
                >
                  <img
                    src={product.sURL}
                    alt={`Product ${index}`}
                    className="h-full w-full object-contain"
                  />
                  <FaInfoCircle
                    className="absolute top-2 right-2 text-blue-500"
                    size={20}
                    onMouseEnter={() => handleMouseEnter(product)}
                    onMouseLeave={handleMouseLeave}
                  />
                  {showTooltip &&
                    tooltipData.iProductId === product.iProductId && (
                      <div
                        style={{
                          position: "absolute",
                          top: "28px",
                          right: "10px",
                          left: "10px",
                        }}
                      >
                        <div
                          className={`bg-white shadow-lg p-2 rounded ${styles.smallBoxdetails}`}
                        >
                          <p>
                            <strong>Name:</strong> {tooltipData.sName}
                          </p>
                          <p>
                            <strong>Body Type:</strong> {tooltipData.sBodyType}
                          </p>
                          <p>
                            <strong>Gender:</strong> {tooltipData.sGender}
                          </p>
                          <p>
                            <strong>Company:</strong> {tooltipData.sStore}
                          </p>{" "}
                          <p>
                            <strong>sku:</strong> {tooltipData.sSKU}
                          </p>
                        </div>
                      </div>
                    )}
                </div>

                <select
                  className="mt-2 w-full px-4 py-2 border rounded-md"
                  value={statuses[index]?.iStatusId}
                  onChange={(e) =>
                    handleStatusChange(
                      index,
                      e.target.value,
                      product.iProductGalleryId
                    )
                  }
                >
                  <option>Select Option</option>
                  {dropdownOptions.map((status) => (
                    <option key={status.iStatusId} value={status.iStatusId}>
                      {status.sName}
                    </option>
                  ))}
                </select>
                {statuses[index]?.iStatusId !== "1" &&
                  statuses[index]?.iStatusId !== "" && (
                    <input
                      type="text"
                      className="mt-2 w-full px-4 py-2 border rounded-md"
                      placeholder="Enter remarks"
                      value={remarks[product.iProductGalleryId] || ""}
                      onChange={(e) =>
                        handleRemarkChange(
                          product.iProductGalleryId,
                          e.target.value
                        )
                      }
                      required
                    />
                  )}
              </div>

              <div
                className=" overflow-x-auto"
                style={{ width: "fit-content" }}
              >
                <div
                  className="overflow-x-auto  flex space-x-4 h-full"
                  style={{ width: "fit-content" }}
                >
                  {product?.models
                    ?.filter(
                      (model) => model.iBodyTypeId === product.iBodyTypeId
                    )
                    .map((model, modalIndex) => (
                      <>
                        <div
                          style={{ padding: "15px", width: "100%" }}
                          className="flex relative items-center justify-center bg bg-[#f4f7fb] shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                        >
                          <div
                            key={modalIndex}
                            className={`bg-gray-300 flex-shrink-0 ${styles.renderedmodelImages}`}
                          >
                            <div className="bg-white rounded-xl p-[10px]">
                              <div
                                className="bg-gray-300 flex-shrink-0 "
                                style={{
                                  position: "relative",
                                  width: imgwidth,
                                  height: "500px",
                                  // height: "500px",
                                }}
                              >
                                <TransformWrapper
                                  minScale={1}
                                  maxScale={2}
                                  disablePadding
                                  centerZoomedOut
                                  smooth
                                  doubleClick={{ disabled: true }}
                                >
                                  <TransformComponent>
                                    <img
                                      src={model.sURL}
                                      alt={`Modal ${modalIndex}`}
                                      className="h-full w-full"
                                    />
                                    {model?.position ? (
                                      <>
                                        {product.iBodyTypeId === 2 ? (
                                          <>
                                            {model?.position?.map(
                                              (position, index) => (
                                                <img
                                                  key={index}
                                                  src={product?.sURL}
                                                  style={{
                                                    position: "absolute",
                                                    top: `${position.top}px`,
                                                    left: `${position.left}px`,
                                                    width: `${position.width}px`,
                                                    height: `${position.height}px`,
                                                    transform: `translateX(-50%)`,
                                                  }}
                                                />
                                              )
                                            )}
                                          </>
                                        ) : product.iBodyTypeId === 3 ? (
                                          <>
                                            {model?.position?.map(
                                              (position, index) => (
                                                <img
                                                  key={index}
                                                  src={product?.sURL}
                                                  style={{
                                                    position: "absolute",
                                                    top: `${position.top}px`,
                                                    left: `${position.left}px`,
                                                    width: `${position.width}px`,
                                                    height: `${position.height}px`,
                                                    transform: `translate(-50%, -50%) rotate(${position.rotationAngle}deg)`,
                                                  }}
                                                />
                                              )
                                            )}
                                          </>
                                        ) : (
                                          <img
                                            src={product?.sURL}
                                            style={{
                                              position: "absolute",
                                              top: `${model?.position.top}px`,
                                              left: `${model?.position.left}px`,
                                              width: `${model?.position.width}px`,
                                              height: `${model?.position.height}px`,
                                              transform: `  ${
                                                product.iBodyTypeId === 4
                                                  ? "translateY(50%)"
                                                  : product.iBodyTypeId === 1
                                                  ? "translate(-50%, -50%)"
                                                  : ""
                                              } rotate(${
                                                model?.position.rotationAngle
                                              }deg)`,
                                            }}
                                          />
                                        )}
                                      </>
                                    ) : null}
                                  </TransformComponent>
                                </TransformWrapper>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductReview;
